import React from "react";
import { TableHeadersType } from "../../../../../constant/tableHeadersConstants/tableHeadersType";
import {
  formatDate,
  formateDateTime,
} from "../../../../../utils/commonFunctions";
type AppProps = {
  gstrOneInvoiceData: any;
  tableHeader: TableHeadersType[];
};
const GstrThreeBInvoiceTableData = ({
  gstrOneInvoiceData,
  tableHeader,
}: AppProps) => {
  const convertDocumentType = (type: string) => {
    switch (type) {
      case "tax_invoice":
        return "Tax Invoice";
      case "credit_note":
        return "Credit Note";
      case "debit_note":
        return "Debit Note";
      case "recepits":
        return "Purchase Order";
      case "rcm_invoice":
        return "Tax Invoice(RCM applicable)";
      default:
        return "";
    }
  };

  const renderGstrOneInvoiceTableData = () => {
    let finalData = gstrOneInvoiceData?.map((item: any) => {
      let tableRow = tableHeader?.map((header: TableHeadersType) => {
        if (header?.value == "name") {
          return (
            <td>
              {item?.customer_name
                ? item?.customer_name
                : item?.seller_name
                ? item?.seller_name
                : "NA"}
            </td>
          );
        } else if (header?.value == "invoice_no") {
          return <td>{item?.invoice_number}</td>;
        } else if (header?.value == "invoice_date") {
          return <td>{formatDate(item?.invoice_date)}</td>;
        } else if (header?.value == "total_amount") {
          return <td>{item?.total_invoice_value?.toFixed(2)}</td>;
        } else if (header?.value === "document_type") {
          return <td>{convertDocumentType(item?.document_type)}</td>;
        }
      });
      return <tr>{tableRow}</tr>;
    });

    return finalData;
  };
  return <>{renderGstrOneInvoiceTableData()}</>;
};

export default GstrThreeBInvoiceTableData;
